import React from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import Pages from "./Pages";
import TypePageConstant from "./TypePageConstant";
import StatePageConstant from "./StatePageConstant";

export default function ViewPage() {
  const params = useParams();
  const pageID = parseInt(params.pageID);
  let page = Pages.filter((page) => page.ID == pageID);
  page = page[0];

  let classBadgeStatePage;
  switch (page.state) {
    case StatePageConstant.statusSiteUserPublisher.PENDING:
      classBadgeStatePage = "badge-warning";
      break;
    case StatePageConstant.statusSiteUserPublisher.CONFIRM:
      classBadgeStatePage = "badge-info";
      break;
    case StatePageConstant.statusSiteUserPublisher.REJECT:
      classBadgeStatePage = "badge-danger";
      break;
    case StatePageConstant.statusSiteUserPublisher.REJECT_EDIT:
      classBadgeStatePage = "badge-danger";
      break;
    case StatePageConstant.statusSiteUserPublisher.PENDING_EDIT:
      classBadgeStatePage = "badge-warning";
      break;
  }

  const generateMessageAdminForRejectPage = () => {
    if (
      page.state == StatePageConstant.statusSiteUserPublisher.REJECT ||
      page.state == StatePageConstant.statusSiteUserPublisher.REJECT_EDIT
    ) {
      return (
        <div className="alert alert-danger">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            دلیل رد شدن صفحه :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>{page.message}</p>
            </li>
          </ul>
        </div>
      );
    }
    return <></>;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`${page.title}  در سایت batmatic-test.ir`} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link className="btn btn-primary" to="/page/all/publisher/1">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {generateMessageAdminForRejectPage()}
              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td
                        colSpan={2}
                        className="text-center"
                        style={{ borderRadius: "25px 25px 0 0" }}
                      >
                        اطلاعات صفحه{" "}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>شماره صفحه</td>
                      <td>{page.ID}</td>
                    </tr>
                    <tr>
                      <td>عنوان صفحه</td>
                      <td>
                        {page.title}
                        {page.pattern.includes("/@s") ? (
                          <span className="pr-2">
                            <span className="badge badge-success">
                              {
                                TypePageConstant.typePageString()[
                                  TypePageConstant.typePage.MULTI_PAGE
                                ]
                              }
                            </span>
                          </span>
                        ) : (
                          <span className="pr-2">
                            <span className="badge badge-warning">
                              {
                                TypePageConstant.typePageString()[
                                  TypePageConstant.typePage.STATIC
                                ]
                              }
                            </span>
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>نوع صفحه</td>
                      <td>
                        {page.pattern.includes("@s")
                          ? TypePageConstant.typePageString()[
                              TypePageConstant.typePage.MULTI_PAGE
                            ]
                          : TypePageConstant.typePageString()[
                              TypePageConstant.typePage.STATIC
                            ]}
                      </td>
                    </tr>
                    <tr>
                      <td>الگوی آدرس</td>
                      <td className="text-left ltr">{page.pattern}</td>
                    </tr>
                    <tr>
                      <td>لینک</td>
                      <td className="text-left ltr">
                        <span>{decodeURI(page.link)}</span>
                        <span className="pl-2">
                          <a
                            className="btn btn-primary"
                            target="_blank"
                            href={page.link}
                          >
                            <i className="fa fa-link"></i>
                          </a>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>وضعیت</td>
                      <td>
                        <span className={`badge ${classBadgeStatePage}`}>
                          {page.state}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>حالت</td>
                      <td>
                        <div dir="ltr">
                          {page.active ? (
                            <span className="badge badge-success">فعال</span>
                          ) : (
                            <span className="badge badge-danger">غیرفعال</span>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>تاریخ درج</td>
                      <td>{page.created_at}</td>
                    </tr>
                    <tr>
                      <td>عکس صفحه</td>
                      <td>
                        <a
                          target="_blank"
                          href={`${process.env.REACT_APP_DOMAIN}/assets/img/${page.image}`}
                        >
                          <img
                            className="border border-success img-fluid"
                            src={`${process.env.REACT_APP_DOMAIN}/assets/img/${page.image}`}
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
